
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, User, Grid3X3 } from 'lucide-react';
import { AllCollectionsTab } from './tabs/AllCollectionsTab';
import { PopularCollectionsTab } from './tabs/PopularCollectionsTab';
import { MyCollectionsTab } from './tabs/MyCollectionsTab';

interface CollectionsTabsProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  playlists: any[] | null;
  popularPlaylists: any[] | null;
  userPlaylists: any[] | null;
  followedPlaylists: any[] | null;
  isLoading: boolean;
  popularLoading: boolean;
  userPlaylistsLoading: boolean;
  followedPlaylistsLoading: boolean;
  isAuthenticated: boolean;
}

export const CollectionsTabs = ({
  activeTab,
  onTabChange,
  playlists,
  popularPlaylists,
  userPlaylists,
  followedPlaylists,
  isLoading,
  popularLoading,
  userPlaylistsLoading,
  followedPlaylistsLoading,
  isAuthenticated
}: CollectionsTabsProps) => {
  // Check for subtab param to pass to MyCollectionsTab
  const handleTabChange = (value: string) => {
    // The URL handling will happen in Collections.tsx 
    // when this callback is triggered
    onTabChange(value);
  };

  // Force a valid tab value based on authentication status
  const getValidTabValue = (currentTab: string): string => {
    if (!isAuthenticated && currentTab === 'my-collections') {
      return 'all';
    }
    return currentTab;
  };

  const validActiveTab = getValidTabValue(activeTab);

  return (
    <Tabs value={validActiveTab} onValueChange={handleTabChange} className="space-y-6">
      <TabsList>
        <TabsTrigger value="all" className="flex items-center gap-2">
          <Grid3X3 className="w-4 h-4" />
          All Collections
        </TabsTrigger>
        <TabsTrigger value="popular" className="flex items-center gap-2">
          <Users className="w-4 h-4" />
          Popular
        </TabsTrigger>
        <TabsTrigger 
          value="my-collections" 
          className="flex items-center gap-2"
          disabled={!isAuthenticated}
        >
          <User className="w-4 h-4" />
          My Collections
        </TabsTrigger>
      </TabsList>

      <TabsContent value="all">
        <AllCollectionsTab playlists={playlists} isLoading={isLoading} />
      </TabsContent>

      <TabsContent value="popular">
        <PopularCollectionsTab playlists={popularPlaylists} isLoading={popularLoading} />
      </TabsContent>

      <TabsContent value="my-collections">
        <MyCollectionsTab 
          userPlaylists={userPlaylists}
          followedPlaylists={followedPlaylists}
          isLoadingUserPlaylists={userPlaylistsLoading}
          isLoadingFollowedPlaylists={followedPlaylistsLoading}
        />
      </TabsContent>
    </Tabs>
  );
};
